import { render, staticRenderFns } from "./SchaefflerHeader.vue?vue&type=template&id=dbacce8c&scoped=true"
import script from "./SchaefflerHeader.vue?vue&type=script&lang=js"
export * from "./SchaefflerHeader.vue?vue&type=script&lang=js"
import style0 from "./SchaefflerHeader.vue?vue&type=style&index=0&id=dbacce8c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbacce8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dbacce8c')) {
      api.createRecord('dbacce8c', component.options)
    } else {
      api.reload('dbacce8c', component.options)
    }
    module.hot.accept("./SchaefflerHeader.vue?vue&type=template&id=dbacce8c&scoped=true", function () {
      api.rerender('dbacce8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SchaefflerHeader.vue"
export default component.exports